class PredefinedLineitemDiscountController extends AbstractEntityEditController
	@register()
	@inject 'predefinedLineitemDiscount',
		'PredefinedLineitemDiscountRepository'

	initialize: ->
		@mainCrud.entityType = 'general.predefined_line_item.discount'
		@mainCrud.entityTitle = 'wbo.predefined_line_item.discount.create.new'

		if @predefinedLineitemDiscount.id?
			if @predefinedLineitemDiscount.value? && @predefinedLineitemDiscount.value != ''
				@predefinedLineitemDiscount.value = @PredefinedLineitemDiscountRepository.getPercentageText(
					@predefinedLineitemDiscount.value
				)
			@mainCrud.entityTitle = @predefinedLineitemDiscount.name
			@mainCrud.isNewEntity = false

	save: ->
		discount = angular.copy(@predefinedLineitemDiscount)
		discount.value = parseFloat(discount.value / 100).toFixed(5).replace(', ', '.')
		@PredefinedLineitemDiscountRepository
			.save discount, @mainCrud.isNewEntity
			.then (response) =>
				response.data.value = @PredefinedLineitemDiscountRepository.getPercentageText(response.data.value)
				@predefinedLineitemDiscount.value = response.data.value
				@afterSave(response)
			.catch (response) =>
				@handleErrors response,

	delete: ->
		@deleteEntity(@PredefinedLineitemDiscountRepository, @predefinedLineitemDiscount)

